import Axios from "axios";
import User from "./User";
import moment from "moment";
import Services from "./Services";
import Vue from "vue";

class SchedulesClass {

  constructor() {
    this.schedules = /** @type {Schedule[]} */ ([]);
    this.initialized = false;
  }

  /**
   *
   * @param {number} id
   * @return {Schedule}
   */
  get(id) {
    return this.schedules.find(s => s.id === id);
  }

  /**
   * @param {number} id
   */
  getForService(id) {
    let toReturn = [];
    for (let schedule of this.schedules) {
      if (schedule.service == id) {
        toReturn.push(schedule);
      }
    }
    if (toReturn.length == 0) {
      return null;
    }
    return toReturn;
  }

  /**
   * @param {number} id
   */
  getForServiceAccordingToFare(id,includePaidSchedules = true) {
    let toReturn = [];
    for (let schedule of this.schedules) {
      if (schedule.service == id && ( schedule.price === 0 || includePaidSchedules)) {
        toReturn.push(schedule);
      }
    }
    if (toReturn.length == 0) {
      return null;
    }
    return toReturn;
  }

  async init() {
    if(!User.token) {
      return;
    }
    let schedules = await Axios.get(CONFIG.urlServer + "/api/booking_entities", {
      params: {
        perPage: -1
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    let newArray = [];
    for (let definition of schedules.data.data) {
      let schedule = new Schedule(definition);
      await schedule.load();
      newArray.push(schedule);
    }
    this.schedules = newArray;
    this.initialized = true;
  }

}

/**
 * @typedef ScheduleDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} name
 * @property {string} type
 * @property {number} service
 * @property {number} price
 * @property {boolean} deleted
 * @property {number} step
 * @property {number} [minimumDuration]
 * @property {number} [maximumDuration]
 * @property {number} [bufferDuration]
 * @property {number} [maximumConcurrentBooking]
 */

class Schedule {

  /**
   * @param {ScheduleDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.name = definition.name;
    this.type = definition.type;
    this.service = definition.service;
    this.price = definition.price || 0;
    this.deleted = definition.deleted;
    this.times = /** @type {Map<String, {from: String, to: String}>} */ (new Map());
    this.step = definition.step;
    this.minimumDuration = definition.minimumDuration || 0;
    this.maximumDuration = definition.maximumDuration || 0;
    this.bufferDuration = definition.bufferDuration || 0;
    this.maximumConcurrentBooking = definition.maximumConcurrentBooking || 0;
    this.entityType = "Schedule";
  }

  getService() {
    return Services.get(this.service);
  }

  async load() {
    let fromToday = moment().format("YYYY-MM-DD") + " 00:00:00";
    let times = await Axios.get(CONFIG.urlServer + "/api/booking_entities/" + this.id + "/schedule", {
      params: {
        from: fromToday
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    for (let time in times.data.available) {
      this.times.set(time, times.data.available[time]);
    }
  }

  /**
   * @param {moment.Moment} start
   * @param {moment.Moment} end
   * @param {number} amount
   * @param {string} token?
   */
  async createReservation(start, end, amount, token) {
    let result = await Axios.post(CONFIG.urlServer + "/api/reservations", {
      entity: this.id,
      payments: [{
        from: token,
        processor: token ? "stripe" : "none",
        amount: amount || 0,
        currency: "CAD"
      }],
      total: amount || 0,
      currency: "CAD",
      start: start.format("YYYY-MM-DD HH:mm:ss"),
      end: end.format("YYYY-MM-DD HH:mm:ss")
    }, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    return result;
  }

}

let Schedules = new SchedulesClass();
export default Schedules;
